var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"p-0",attrs:{"id":"website","fluid":""}},[_c('Nav'),_c('div',{staticStyle:{"margin-bottom":"7rem !important"}},[(_vm.hasRequest)?_c('div',{staticClass:"req-loader"},[_c('img',{attrs:{"src":require("@/assets/logo.svg"),"width":"120","alt":"loader_logo"}})]):_vm._e(),_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }